import { render, staticRenderFns } from "./drugInfoCard.vue?vue&type=template&id=8f02799a&scoped=true"
import script from "./drugInfoCard.vue?vue&type=script&lang=js"
export * from "./drugInfoCard.vue?vue&type=script&lang=js"
import style0 from "./drugInfoCard.vue?vue&type=style&index=0&id=8f02799a&prod&lang=scss&scoped=true"
import style1 from "./drugInfoCard.vue?vue&type=style&index=1&id=8f02799a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f02799a",
  null
  
)

export default component.exports